import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import OfflineBanner from './Component/OfflineBanner';

// Home Components
import Home from './home/Home';
import Navbar from './home/Navbar';


// Syllabus Components
import Syllabus from './Books/syllabus/Syllabus';
import SyllabusPhys from './Books/syllabus/subjects/SyllabusPhys';
import SyllabusChem from './Books/syllabus/subjects/SyllabusChem';
import SyllabusBio from './Books/syllabus/subjects/SyllabusBio';


// Practice Questions Components
import PracticeQuestions from './Practics/practicequestions/PracticeQuestions';
import PracticeQuestionsPhysTopics from './Practics/practicequestions/subjects/PracticeQuestionsPhysTopics';
import PracticeQuestionsChemTopics from './Practics/practicequestions/subjects/PracticeQuestionsChemTopics';
import PracticeQuestionsBioTopics from './Practics/practicequestions/subjects/PracticeQuestionsBioTopics';

// Previous Year Questions Components
import PreviousYearQuestions from './Practics/previousyearquestions/PreviousYearQuestions';
import PreviousYearQuestionsPhysTopics from './Practics/previousyearquestions/subjects/PreviousYearQuestionsPhysTopics';
import PreviousYearQuestionsChemTopics from './Practics/previousyearquestions/subjects/PreviousYearQuestionsChemTopics';
import PreviousYearQuestionsBioTopics from './Practics/previousyearquestions/subjects/PreviousYearQuestionsBioTopics';


// Quiz Components
import Quiz from './MockTest/MockTest/Quiz';
import QuizPhysicsTopics from './MockTest/MockTest/subjects/QuizPhysicsTopics';
import QuizChemistryTopics from './MockTest/MockTest/subjects/QuizChemistryTopics';
import QuizBiologyTopics from './MockTest/MockTest/subjects/QuizBiologyTopics';
import QuizStarting from './MockTest/QuizStarting';
import QuizReStarting from './MockTest/QuizReStarting';
import QuizDetailsPage from './MockTest/QuizDetailsPage';
import QuizNumber from './MockTest/QuizNumber';
import NumberOfQuestions from './MockTest/NumberOfQuestions';

import OnlinePracticsQuestions from './Practics/OnlinePracticsQuestions';
import QuestionSolution from './Practics/QuestionSolution';
import BookmarkedQuestions from './Practics/BookMarkedQuestions';
import QuestionHistory from './Practics/QuestionHistory';
import SubjectProgress from './Practics/SubjectProgress';

import TopImportantQuestionSubject from './subjects/TopImportantQuestionSubject';
import PracticsImportantQuestions from './Practics/topimportantquestions/PracticsImportantQuestions';
import PracticsQuestionTopics from './topics/PracticsQuestionTopics';
import PageNotFound from './home/PageNotFound';
import PdfsBookmark from './Books/PdfsBookmark';
import OnlineReadBook from './Books/OnlineReadBook';


import PreviousYearMockTest from './MockTest/PYQMockTest/PreviousYearMockTest';
import QuizYear from './MockTest/PYQMockTest/QuizYear';
import NumberOfQuestionsYear from './MockTest/NumberOfQuestionsYear';

import ChapterWiseWeightage from './Pages/ChapterWiseWeightage/ChapterWiseWeightage';
import ChapterWiseWeightagePhysTopics from './Pages/ChapterWiseWeightage/subjects/ChapterWiseWeightagePhysTopics';
import ChapterWiseWeightageChemTopics from './Pages/ChapterWiseWeightage/subjects/ChapterWiseWeightageChemTopics';
import ChapterWiseWeightageBioTopics from './Pages/ChapterWiseWeightage/subjects/ChapterWiseWeightageBioTopics';
import NeetWeightageBiology from './Pages/ChapterWiseWeightage/subjects/NeetWeightageBiology';
import NeetWeightagePhysics from './Pages/ChapterWiseWeightage/subjects/NeetWeightagePhysics';
import NeetWeightageChemistry from './Pages/ChapterWiseWeightage/subjects/NeetWeightageChemistry';
import AllNeetWeightageBiology from './Pages/ChapterWiseWeightage/subjects/AllNeetWeightageBiology';
import AllNeetWeightagePhysics from './Pages/ChapterWiseWeightage/subjects/AllNeetWeightagePhysics';
import AllNeetWeightageChemistry from './Pages/ChapterWiseWeightage/subjects/AllNeetWeightageChemistry';
import WeightagePhysics2026 from './Pages/ChapterWiseWeightage/subjects/WeightagePhysics2026';
import WeightageChemistry2026 from './Pages/ChapterWiseWeightage/subjects/WeightageChemistry2026';
import WeightageBiology2026 from './Pages/ChapterWiseWeightage/subjects/WeightageBiology2026';


import Bottombar from './home/Bottombar';
import HelpSupport from './Pages/HelpSuport';
import About from './Pages/About';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import Footer from './home/Footer';
import ContactSupport from './Contact/Contact';
import PDFViewer from './Books/PDFViwer';
import MoreOptions from './home/MoreOptions';
import NcertBooks from './Books/NcertBook/NcertBooks';
import NcertBookPhysTopics from './Books/NcertBook/subjects/NcertBookPhysTopics';
import NcertBookChemTopics from './Books/NcertBook/subjects/NcertBookChemTopics';
import NcertBookBioTopics from './Books/NcertBook/subjects/NcertBookBioTopics';
import NcertShortNote from './Books/NcertShortNote/NcertShortNote';
import NcertShortNotePhysTopics from './Books/NcertShortNote/subjects/NcertShortNotePhysTopics';
import NcertShortNoteChemTopics from './Books/NcertShortNote/subjects/NcertShortNoteChemTopics';
import NcertShortNoteBioTopics from './Books/NcertShortNote/subjects/NcertShortNoteBioTopics';
import NcertSolutions from './Books/NcertSolution/NcertSolutions';
import NcertSolutionPhysTopics from './Books/NcertSolution/subjects/NcertSolutionPhysTopics';
import NcertSolutionChemTopics from './Books/NcertSolution/subjects/NcertSolutionChemTopics';
import NcertSolutionBioTopics from './Books/NcertSolution/subjects/NcertSolutionBioTopics';
import Formulas from './Books/Formulas/Formulas';
import FormulaPhysTopics from './Books/Formulas/subjects/FormulaPhysTopics';
import FormulaChemTopics from './Books/Formulas/subjects/FormulaChemTopics';
import FormulaBioTopics from './Books/Formulas/subjects/FormulaBioTopics';
import ChapterWisePYQ from './Practics/ChapterWisePYQ/ChapterWisePYQ';
import ChapterWisePYQPhysTopics from './Practics/ChapterWisePYQ/subjects/ChapterWisePYQPhysTopics';
import ChapterWisePYQChemTopics from './Practics/ChapterWisePYQ/subjects/ChapterWisePYQChemTopics';
import ChapterWisePYQBioTopics from './Practics/ChapterWisePYQ/subjects/ChapterWisePYQBioTopics';
import DiagramQuestions from './Practics/DiagramQuestion/DiagramQuestions';
import DiagramQuestionPhysTopics from './Practics/DiagramQuestion/subjects/DiagramQuestionPhysTopics';
import DiagramQuestionChemTopics from './Practics/DiagramQuestion/subjects/DiagramQuestionChemTopics';
import DiagramQuestionBioTopics from './Practics/DiagramQuestion/subjects/DiagramQuestionBioTopics';
import ReportSend from './Contact/ReportSend';
import ReportQuestion from './Backend/UserDoubt';
import ReportQuestionDetails from './Contact/ReportQuestionDetails';
import Flashcards from './Books/Flashcards/Flashcard';
import FlashcardPhysTopics from './Books/Flashcards/subjects/FlashcardPhysTopics';
import FlashcardChemTopics from './Books/Flashcards/subjects/FlashcardChemTopics';
import FlashcardBioTopics from './Books/Flashcards/subjects/FlashcardBioTopics';
import Mindmap from './Books/Mindmaps/Mindmap';
import MindmapPhysTopics from './Books/Mindmaps/subjects/MindmapPhysTopics';
import MindmapChemTopics from './Books/Mindmaps/subjects/MindmapChemTopics';
import MindmapBioTopics from './Books/Mindmaps/subjects/MindmapBioTopics';
import ToperNotes from './Books/ToperNote/ToperNotes';
import ToperNotePhysTopics from './Books/ToperNote/subjects/ToperNotePhysTopics';
import ToperNoteChemTopics from './Books/ToperNote/subjects/ToperNoteChemTopics';
import ToperNoteBioTopics from './Books/ToperNote/subjects/ToperNoteBioTopics';
import Login from './Auth/Login';
import SignUp from './Auth/SignUp';
import Logout from './Auth/Logout';
import Profile from './Auth/Profile';
import UpdateProfile from './Auth/UpdateProfile';
import AccountDelete from './Auth/AccountDelete';
import TermsAndConditions from './Pages/TermsAndConditions';
import AccountDeletionInstructions from './Auth/AccountDeletionInstructions';


import AdminHome from './Backend/AdminHome';
import AllUsersBeforeLogin from './Backend/AllUsersBeforeLogin';
import AllUsers from './Backend/AllUsers';
import AppInstallUsers from './Backend/AppInstallUsers';
import AppItemsUse from './Backend/AppItemsUse';
import PaymentItems from './Backend/PaymentItems';
import AllPayments from './Backend/AllPayments';



import PaymentSuccess from './Payment/PaymentSuccess';
import Pay from './Payment/Pay';
import PaymentDetails from './Payment/PaymentDetails';
import ProductList from './Payment/ProductList';
import PaymentSuccessFail from './Payment/PaymentSuccessFail';
import PremiumPaywall from './Payment/PremiumPaywall';
import RefundPolicy from './Pages/RefundPolicy';
import ShippingPolicy from './Pages/ShippingPolicy';
import PayRazorpay from './Payment/PayRazorpay';
import RegisterBeforePayment from './Auth/RegisterBeforePayment';
import StudentFeedback from './Contact/StudentFeedback';
import OPTondonBook from './Books/OPTondon/OPTondonBook';
import OPTondonChemiTopics from './Books/OPTondon/subjects/OPTondonChemiTopics';
import ErrorLessBook from './Books/ErrorLess/ErrorLessBook';
import ErrorLessBioTopics from './Books/ErrorLess/subjects/ErrorLessBioTopics';
import NEETImportantInfoTopic from './Pages/NEETImportantInfo/NEETImportantInfoTopic';
import NEETCutoff2027 from './Pages/NEETImportantInfo/NEETInfoPage/NEETCutoff2027';
import NEETEligibilityCriteria2027 from './Pages/NEETImportantInfo/NEETInfoPage/NEETEligibilityCriteria2027';
import NEETExamPattern2027 from './Pages/NEETImportantInfo/NEETInfoPage/NEETExamPattern2027';
import Preparation2027 from './Pages/NEETImportantInfo/NEETInfoPage/Preparation2027';
import FAQs2027 from './Pages/NEETImportantInfo/NEETInfoPage/FAQs2027';
import { OnlineStatus } from './Component/OnlineStatus';
import QuestionImageLoad from './topics/QuestionImageLoad';


import Page from './Pages/TestingPage/Page.js';
import AccountAccess from './Auth/AccountAccess.js';




const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

const AppContent = () => {

  const location = useLocation();

  const isOnline = OnlineStatus();

  return (

    <>

      {!isOnline && (<OfflineBanner />)}

      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&

        <Navbar />}

      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        !location.pathname.startsWith('/online-practics-questions') &&
        !location.pathname.startsWith('/practivs-important-questions') &&
        !location.pathname.startsWith('/practice-random-question/all') &&
        !location.pathname.startsWith('/practice-random-question/physics') &&
        !location.pathname.startsWith('/practice-random-question/chemistry') &&
        !location.pathname.startsWith('/practice-random-question/biology') &&
        !location.pathname.startsWith('/pdfviewer') &&
        !location.pathname.startsWith('/onlinereadbook') &&
        !location.pathname.startsWith('/account-deletion') &&
        !location.pathname.startsWith('/product-list') &&
        !location.pathname.startsWith('/pay-payment') &&
        !location.pathname.startsWith('/pay-razorpay') &&
        !location.pathname.startsWith('/student-feedback') &&

        <Bottombar />}

      <Routes>

                <Route path="/page" element={<Page />} />


        <Route path='/' element={<Home />} />
        <Route path="/contact" element={<ContactSupport />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<HelpSupport />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />


        <Route path="/report-send/:id" element={<ReportSend />} />
        <Route path="/report-question" element={<ReportQuestion />} />
        <Route path="/report-question-details/:id/:displayId/:message" element={<ReportQuestionDetails />} />

        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/register-before-payment" element={<RegisterBeforePayment />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/update-profile" element={<UpdateProfile />} />
        <Route path="/account-delete" element={<AccountDelete />} />
        <Route path="/account-deletion" element={<AccountDeletionInstructions />} />
        <Route path="/account-access/:userPhone" element={<AccountAccess />} />



       {/*  Bckend side page */}
        <Route path='admin-home' element={<AdminHome />} />
        <Route path="/all-users-data" element={<AllUsers />} />
        <Route path="/all-users-before-login" element={<AllUsersBeforeLogin />} />
        <Route path="/app-install-users" element={<AppInstallUsers />} />
        <Route path="/app-items-use" element={<AppItemsUse />} />
        <Route path="/all-payment-items" element={<PaymentItems />} />
        <Route path="/all-payments" element={<AllPayments />} />



        {/* payments */}
        <Route path="/premium-paywall" element={<PremiumPaywall />} />
        <Route path="/product-list" element={<ProductList />} />
        <Route path="/pay-payment/:item/:userId" element={<Pay />} />
        <Route path="/payment-details/:item/:userId" element={<PaymentDetails />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-success-fail/:payment_id" element={<PaymentSuccessFail />} />
        <Route path="/pay-razorpay/:id" element={<PayRazorpay />} />

        <Route path="/neet-important-info" element={<NEETImportantInfoTopic />} />
        <Route path="/cutoff-2027" element={<NEETCutoff2027 />} />
        <Route path="/eligibility-criteria-2027" element={<NEETEligibilityCriteria2027 />} />
        <Route path="/exam-pattern-2027" element={<NEETExamPattern2027 />} />
        <Route path="/preparation-2027" element={<Preparation2027 />} />
        <Route path="/faq-2027" element={<FAQs2027 />} />




        <Route path="/more-options" element={<MoreOptions />} />

        <Route path="/question-image-load/:subject/:topic/:type" element={<QuestionImageLoad />} />
        <Route path="/online-practics-questions/:subject/:topic/:type" element={<OnlinePracticsQuestions />} />
        <Route path="/question-solution/:id" element={<QuestionSolution />} />
        <Route path="/bookmarked-questions" element={<BookmarkedQuestions />} />
        <Route path="/bookmarked-pdfs" element={<PdfsBookmark />} />
        <Route path="/questions-history" element={<QuestionHistory />} />
        <Route path="/subject-progress" element={<SubjectProgress />} />
        <Route path="/practice-question-topics" element={<PracticsQuestionTopics />} />
        <Route path="/pdfviewer/:id" element={<PDFViewer />} />
        <Route path="/onlinereadbook/:type/:subject/:topic" element={<OnlineReadBook />} />
        <Route path="/student-feedback" element={<StudentFeedback />} />



        <Route path="/chapter-wise-weightage/physics/physics-weightage-2026" element={<WeightagePhysics2026 />} />
        <Route path="/chapter-wise-weightage/chemistry/chemistry-weightage-2026" element={<WeightageChemistry2026 />} />
        <Route path="/chapter-wise-weightage/biology/biology-weightage-2026" element={<WeightageBiology2026 />} />
        <Route path="/chapter-wise-weightage/physics/physics-weightage-2025" element={<NeetWeightagePhysics />} />
        <Route path="/chapter-wise-weightage/chemistry/chemistry-weightage-2025" element={<NeetWeightageChemistry />} />
        <Route path="/chapter-wise-weightage/biology/biology-weightage-2025" element={<NeetWeightageBiology />} />
        <Route path="/chapter-wise-weightage/physics/physics-weightage-2020-24" element={<AllNeetWeightagePhysics />} />
        <Route path="/chapter-wise-weightage/chemistry/chemistry-weightage-2020-24" element={<AllNeetWeightageChemistry />} />
        <Route path="/chapter-wise-weightage/biology/biology-weightage-2020-24" element={<AllNeetWeightageBiology />} />



        {/* NCERT Books */}
        <Route path="/syllabus" element={<Syllabus />} />
        <Route path="/syllabus/physics" element={<SyllabusPhys />} />
        <Route path="/syllabus/chemistry" element={<SyllabusChem />} />
        <Route path="/syllabus/biology" element={<SyllabusBio />} />

        {/* NCERT Books */}
        <Route path="/ncertbook" element={<NcertBooks />} />
        <Route path="/ncertbook/physics" element={<NcertBookPhysTopics />} />
        <Route path="/ncertbook/chemistry" element={<NcertBookChemTopics />} />
        <Route path="/ncertbook/biology" element={<NcertBookBioTopics />} />

        {/* NCERT Short Note */}
        <Route path="/ncert-short-note" element={<NcertShortNote />} />
        <Route path="/ncert-short-note/physics" element={<NcertShortNotePhysTopics />} />
        <Route path="/ncert-short-note/chemistry" element={<NcertShortNoteChemTopics />} />
        <Route path="/ncert-short-note/biology" element={<NcertShortNoteBioTopics />} />

        {/* NCERT Solution */}
        <Route path="/ncert-solutions" element={<NcertSolutions />} />
        <Route path="/ncert-solutions/physics" element={<NcertSolutionPhysTopics />} />
        <Route path="/ncert-solutions/chemistry" element={<NcertSolutionChemTopics />} />
        <Route path="/ncert-solutions/biology" element={<NcertSolutionBioTopics />} />

        {/* NCERT Formula */}
        <Route path="/formulas" element={<Formulas />} />
        <Route path="/formulas/physics" element={<FormulaPhysTopics />} />
        <Route path="/formulas/chemistry" element={<FormulaChemTopics />} />
        <Route path="/formulas/biology" element={<FormulaBioTopics />} />

        {/* NCERT Flashcard */}
        <Route path="/flashcards" element={<Flashcards />} />
        <Route path="/flashcards/physics" element={<FlashcardPhysTopics />} />
        <Route path="/flashcards/chemistry" element={<FlashcardChemTopics />} />
        <Route path="/flashcards/biology" element={<FlashcardBioTopics />} />

        {/* NCERT MindMap */}
        <Route path="/mindmaps" element={<Mindmap />} />
        <Route path="/mindmaps/physics" element={<MindmapPhysTopics />} />
        <Route path="/mindmaps/chemistry" element={<MindmapChemTopics />} />
        <Route path="/mindmaps/biology" element={<MindmapBioTopics />} />

        {/* Toper Notes */}
        <Route path="/topernote" element={<ToperNotes />} />
        <Route path="/topernote/physics" element={<ToperNotePhysTopics />} />
        <Route path="/topernote/chemistry" element={<ToperNoteChemTopics />} />
        <Route path="/topernote/biology" element={<ToperNoteBioTopics />} />


        {/* OP Tondon */}
        <Route path="/op-tondon-book" element={<OPTondonBook />} />
        <Route path="/op-tondon-book/chemistry" element={<OPTondonChemiTopics />} />


        {/* Errorless */}
        <Route path="/errorless-book" element={<ErrorLessBook />} />
        <Route path="/errorless-book/biology" element={<ErrorLessBioTopics />} />




        {/* Practice Questions */}
        <Route path="/practice-questions" element={<PracticeQuestions />} />
        <Route path="/practice-question-topics/physics" element={<PracticeQuestionsPhysTopics />} />
        <Route path="/practice-question-topics/chemistry" element={<PracticeQuestionsChemTopics />} />
        <Route path="/practice-question-topics/biology" element={<PracticeQuestionsBioTopics />} />

        {/* Previous Year Questions */}
        <Route path="/previous-year-questions" element={<PreviousYearQuestions />} />
        <Route path="/previous-year-questions/physics" element={<PreviousYearQuestionsPhysTopics />} />
        <Route path="/previous-year-questions/chemistry" element={<PreviousYearQuestionsChemTopics />} />
        <Route path="/previous-year-questions/biology" element={<PreviousYearQuestionsBioTopics />} />


        {/* Chapter Wise PYQ */}
        <Route path="/chapter-wise-pyq" element={<ChapterWisePYQ />} />
        <Route path="/chapter-wise-pyq/physics" element={<ChapterWisePYQPhysTopics />} />
        <Route path="/chapter-wise-pyq/chemistry" element={<ChapterWisePYQChemTopics />} />
        <Route path="/chapter-wise-pyq/biology" element={<ChapterWisePYQBioTopics />} />

        {/* Diagram based questions */}
        <Route path="/diagram-based-questions" element={<DiagramQuestions />} />
        <Route path="/diagram-based-questions/physics" element={<DiagramQuestionPhysTopics />} />
        <Route path="/diagram-based-questions/chemistry" element={<DiagramQuestionChemTopics />} />
        <Route path="/diagram-based-questions/biology" element={<DiagramQuestionBioTopics />} />


        {/* Notes */}
        <Route path="/chapter-wise-weightage" element={<ChapterWiseWeightage />} />
        <Route path="/chapter-wise-weightage/physics" element={<ChapterWiseWeightagePhysTopics />} />
        <Route path="/chapter-wise-weightage/chemistry" element={<ChapterWiseWeightageChemTopics />} />
        <Route path="/chapter-wise-weightage/biology" element={<ChapterWiseWeightageBioTopics />} />

        {/* Top impotant questions*/}
        <Route path="/top-important-questions" element={<TopImportantQuestionSubject />} />
        <Route path="/practivs-important-questions/:subject/:name" element={<PracticsImportantQuestions />} />




        {/* Quiz Routes (no navbar) */}
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/quiz/physics" element={<QuizPhysicsTopics />} />
        <Route path="/quiz/chemistry" element={<QuizChemistryTopics />} />
        <Route path="/quiz/biology" element={<QuizBiologyTopics />} />
        <Route path="/quiz-starting/:type/:subject/:topic/:quizNo/:quesNum/:subjectName" element={<QuizStarting />} />
        <Route path="/quiz-restarting/:quizId" element={<QuizReStarting />} />
        <Route path="/quiz-details/:quizId/:type/:subject/:topic/:quizNo/:subjectName" element={<QuizDetailsPage />} />
        <Route path="/quiz-number/:type/:subject/:topic/:subjectName" element={<QuizNumber />} />
        <Route path="/number-of-questions/:type/:subject/:topic/:quizNo/:subjectName" element={<NumberOfQuestions />} />
        <Route path="/number-of-questions-year/:type/:subject/:topic/:quizNo/:subjectName" element={<NumberOfQuestionsYear />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="/previouse-year-quiz" element={<PreviousYearMockTest />} />
        <Route path="/quiz-year/:type/:subject/:topic/:subjectName" element={<QuizYear />} />

      </Routes>

      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        !location.pathname.startsWith('/online-practics-questions') &&
        !location.pathname.startsWith('/practivs-important-questions') &&
        !location.pathname.startsWith('/practice-random-question/all') &&
        !location.pathname.startsWith('/practice-random-question/physics') &&
        !location.pathname.startsWith('/practice-random-question/chemistry') &&
        !location.pathname.startsWith('/practice-random-question/biology') &&
        !location.pathname.startsWith('/onlinereadbook') &&

        <Footer />}

    </>

  );
};

export default App;